import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SWRConfig } from "swr";
import { fetcher } from "../utils/api";
import GlobalStyles from "../styles/global";

import RequireAuth from "../routes/RequireAuth";
import AppShell from "../components/AppShell";

import LoginPage from "../pages/LoginPage";
import VerifyPage from "../pages/VerifyPage";
import InboxPage from "../pages/InboxPage";
import OutboxPage from "../pages/OutboxPage";
import NewRequestPage from "../pages/NewRequestPage";
import BranchChangeForm from "../pages/new/BranchChangeForm";
import ConsultationRequestForm from "../pages/new/ConsultationRequestForm";
import RequestDetailPage from "../pages/RequestDetailPage";

function App() {
  return (
    <SWRConfig
      value={{
        fetcher,
        revalidateOnFocus: false,
        shouldRetryOnError: false,
      }}
    >
      <GlobalStyles />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/check" element={<VerifyPage />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/" element={<InboxPage />} />
          <Route path="/sent" element={<OutboxPage />} />
          <Route path="/new" element={<NewRequestPage />} />
          <Route path="/new/branch" element={<BranchChangeForm />} />
          <Route path="/new/consultation" element={<ConsultationRequestForm />} />
          <Route path="/requests/:id" element={<RequestDetailPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SWRConfig>
  );
}

export default App;
